<template>
    <div :class="{['payment-method-popup'] :true,['hide'] : popupOpen !== 'paymentMethod'}">
   
        <div class="popup" ref="paymentMethodPopup">
            <div class="title-section">
                <h2>{{ $t('dash.settings.billing.card.billing_information.method.title') }}</h2>
                <p>{{ $t('dash.settings.billing.addMethod.subtitle') }}</p>
            </div>

            <div class="content-form" >
                <div class="card" :class="[{open: methodChoice == 'card'}]">
                    <header @click="methodChoice = 'card'">
                        <div class="circle active"><div></div></div>
                        <p>{{ $t('dash.settings.billing.addMethod.method_card.title') }}</p>
                        <div class="fa-brands fa-cc-visa"></div>
                        <div class="fa-brands fa-cc-mastercard"></div>
                    </header>
                    <div class="content">
                            <div class="container-input number-card">
                                <label>{{ $t('dash.settings.billing.addMethod.method_card.number_card') }}</label>
                                <div class="input">
                                    <i class="fa-regular fa-credit-card"></i>
                                    <div id="card-number" class="inputStripe"></div>
                                </div>
                                <div class="error"><i v-if="cardNumberError" class="fa-regular fa-circle-exclamation"></i>{{ cardNumberError }}</div>
                            </div>
                            <div class="container-input name-card">
                                <label>{{ $t('dash.settings.billing.addMethod.method_card.name_card') }}</label>
                                <div class="input">
                                    <i class="fa-regular fa-circle-user"></i>
                                    <input placeholder="ex. John Smith" v-model="nameCardValue">                                 
                                </div>
                                <div class="error"><i v-if="cardNameError" class="fa-regular fa-circle-exclamation"></i>{{ cardNameError }}</div>
                            </div>
                            <div class="last-line">
                                <div class="container-input expire-card">
                                    <label>{{ $t('dash.settings.billing.addMethod.method_card.expire_card') }}</label>
                                    <div class="input">
                                        <i class="fa-regular fa-calendar"></i>
                                        <div id="card-expiry" class="inputStripe"></div>
                                    </div>
                                    
                                </div>

                                <div class="container-input key-card">
                                    <label>{{ $t('dash.settings.billing.addMethod.method_card.security_card') }}</label>
                                    <div class="input">
                                        <i class="fa-regular fa-key"></i>
                                        <div id="card-cvc" class="inputStripe"></div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="error"><i v-if="stripeError || cardExpiryError || cardCvcError" class="fa-regular fa-circle-exclamation"></i>{{ stripeError || cardExpiryError || cardCvcError }}</div>
                    </div>
                </div>

                <div class="card" :class="[{open: methodChoice == 'sepa'}]">
                    <header @click="methodChoice = 'sepa'">
                        <div class="circle active"><div></div></div>
                        <p>{{ $t('dash.settings.billing.addMethod.method_sepa.title') }}</p>
                    </header>
                    <div class="content">
                        <div class="container-input name-card">
                            <label>{{ $t('dash.settings.billing.addMethod.method_sepa.name') }}</label>
                            <div class="input">
                                <i class="fa-regular fa-circle-user"></i>
                                <input placeholder="ex. John Smith" v-model="nameIbanValue" required>                                 
                            </div>
                            <div class="error"><i v-if="nameIbanError" class="fa-regular fa-circle-exclamation"></i>{{ nameIbanError }}</div>
                        </div>
                        <div class="container-input email-card">
                            <label>{{ $t('dash.settings.billing.addMethod.method_sepa.email') }}</label>
                            <div class="input">
                                <i class="fa-regular fa-envelope"></i>
                                <input placeholder="ex. john.smith@example.com" v-model="emailIbanValue" required>                                 
                            </div>
                            <div class="error"><i v-if="emailIbanError" class="fa-regular fa-circle-exclamation"></i>{{ emailIbanError }}</div>
                        </div>
                        <div class="container-input iban">
                            <label>{{ $t('dash.settings.billing.addMethod.method_sepa.iban') }}</label>
                            <div class="input">
                                <i class="fa-regular fa-credit-card"></i>
                                <div id="iban-element" class="inputStripe"></div>
                            </div>
                            <div id="mandate-acceptance">
                                {{ $t('dash.settings.billing.addMethod.method_sepa.mandat_acceptance') }}
                            </div>
                            <div class="error"><i v-if="ibanError" class="fa-regular fa-circle-exclamation"></i>{{ ibanError }}</div>
                        </div>
                    </div>
                </div>
                <div class="card" :class="[{open: methodChoice == 'paypal'}]">
                    <header @click="methodChoice = 'paypal'">
                        <div class="circle"><div></div></div>
                        <p>Paypal</p>
                        <div class="fa-brands fa-cc-paypal"></div>
                    </header>
                </div>
                <div class="btns">
                    <div class="btn-outline-primary" :class="{disabled: loading}" @click="cancel">{{ $t('dash.button.cancel') }}</div>
                    <div class="btn-primary icon-r" :class="{disabled: loading}" @click="submitFormToCreateToken">
                        {{ $t('dash.button.add') }}
                        <i v-if="loading" class="fa-solid fa-spinner fa-spin"></i>
                    </div>
                </div>
            </div>

            <div class="content-loading" hidden>
                <p>{{ $t('dash.settings.billing.addMethod.method_card.loading') }}</p>
            </div>
        </div>
                
    </div>
</template>
<script>

const { VUE_APP_STRIPE_KEY, VUE_APP_API_HOST } = process.env

import PaymentMethodMixins from './../../mixins/PaymentMethod.vue'

export default {
    name: 'paymentMethodPopup',

    props : {
        closePopUp : Function,
        popupOpen : String
    },
    mixins: [PaymentMethodMixins],
    data() {
        return {
            methodChoice: 'card',

            //validation (bool)
            card: {
                cvc: '',
                number: '',
                expiry: ''
            },

            iban: '',

            style : {
                base : { //task clement a convertir en rem plus tard
                    fontFamily: '"THICCCBOI"',
                    lineHeight: '36.8px',
                    fontSize : '13.6px',
                    color : '#555E75',
                    fontWeight : '600',
                    
                    ['::placeholder'] : {
                        fontWeight: '500',
                        color: 'rgba(85, 94, 117, 0.34)'
                    },

                    
                },
                invalid: {
                    color: '#FF5C5C',
                },

            },

            stripe: null,

            //conf
            clientSecret: null,
            clientSecretRoute: `${VUE_APP_API_HOST}/accounts/me/secret`,
            // apiRoute: defined in mixin

            //elements 
            cardNumber: '',
            cardExpiry: '',
            cardCvc: '',

            //value other input 
            nameCardValue: '',
            
            ibanEl: '',
            nameIbanValue: '',
            emailIbanValue: '',

            // errors
            stripeError: '',
            cardCvcError: '',
            cardExpiryError: '',
            cardNumberError: '',
            cardNameError: '',

            ibanError: '',
            nameIbanError: '',
            emailIbanError: '',
            
            loading: false,
        };
    },

    mounted() {
        this.setUpStripe()
    },

    watch : {
        popupOpen() {
            if (this.popupOpen === 'paymentMethod') {   
                window.addEventListener('click', this.handleClickOutside);
            }else{
                window.removeEventListener("click", this.handleClickOutside, false);
            }
        }
    },


    methods: {
        //Stripe
        setUpStripe(){
            this.stripe = Stripe(VUE_APP_STRIPE_KEY) // eslint-disable-line
            const locale = localStorage.language ? localStorage.language.substring(0,2) : 'fr'

            //initialisation
            const elements = this.stripe.elements({ locale })

            this.cardNumber = elements.create('cardNumber',{style: this.style});
            this.cardCvc = elements.create('cardCvc',{style: this.style});
            this.cardExpiry = elements.create('cardExpiry',{style: this.style});
            
            this.cardNumber.mount('#card-number');
            this.cardCvc.mount('#card-cvc');
            this.cardExpiry.mount('#card-expiry');

            //sepa
            const options = {
                style: this.style,
                supportedCountries: ['SEPA'],
                // Elements can use a placeholder as an example IBAN that reflects
                // the IBAN format of your customer's country. If you know your
                // customer's country, we recommend passing it to the Element as the
                // placeholderCountry.
                // placeholderCountry: 'DE',
            };
            this.ibanEl = elements.create('iban', options);

            this.ibanEl.mount('#iban-element');
            

            this.listenForErrors()
        },

        listenForErrors() {
            const vm = this;
            this.cardNumber.addEventListener('change', (event) => {
                if(!event.complete && event.error && event.error.message) {
                    this.cardNumberError = event.error.message
                }else{
                    this.cardNumberError = ''
                }
                this.card.number = event.complete ? true : false
            });
                    
            this.cardExpiry.addEventListener('change', (event) => {
                if(!event.complete && event.error && event.error.message) {
                    this.cardExpiryError = event.error.message
                }else{
                    this.cardExpiryError = ''
                }
                this.card.expiry = event.complete ? true : false
            });
            
            this.cardCvc.addEventListener('change', (event) => {
                if(!event.complete && event.error && event.error.message) {
                    this.cardCvcError = event.error.message
                }else{
                    this.cardCvcError = ''
                }
                this.card.cvc = event.complete ? true : false
            });

            this.ibanEl.addEventListener('change', (event) => {
                if(!event.complete && event.error && event.error.message) {
                    this.ibanError = event.error.message
                }else{
                    this.ibanError = ''
                }
                this.iban = event.complete ? true : false
            });
        },

        submitFormToCreateToken() {
            // Block double submit: each click creates a new SetupIntent + PUT (and an internal mail)
            if (this.loading) return

            this.clearCardErrors();
            this.clearIbanErrors()
            let valid = true;

            if(this.methodChoice == 'card') {
                if (!this.card.number) {
                    valid = false;
                    this.cardNumberError = "Un numéro de carte valide est requis";
                }
                if (!this.card.cvc) {
                    valid = false;
                    this.cardCvcError = "Le CVC de la carte est requis";
                }
                if (!this.card.expiry) {
                    valid = false;
                    this.cardExpiryError = "La date d'expiration de la carte est requise";
                }
                if (this.nameCardValue == '' || this.nameCardValue.length <= 0) {
                    valid = false;
                    this.cardNameError = "Le nom de la carte est requis";
                }
    
                if (this.stripeError) {
                    valid = false;
                }
            }
            
            else if(this.methodChoice == 'sepa') {
                if (!this.iban) {
                    valid = false;
                    this.ibanError = "Un numéro IBAN valide est requis";
                }
            }

            if (valid) {
                this.createToken()
            }
        },

        async createToken() {
            this.loading = true
            try {
                await this.saveNewPaymentMethod()
            } catch (err) {
                console.error('Could not save payment method: ', err)
                this.$vs.notify({
                    title: this.$t('dash.notifications.error_title'),
                    text : this.$t('dash.settings.payment_method.failure')
                });
            } finally {
                this.loading = false
            }
        },

        async saveNewPaymentMethod() {
            // if (!this.clientSecret) await this.fetchSecret();
            await this.fetchSecret();
            if (!this.clientSecret) return

            const {setupIntent, error} = this.methodChoice == 'card' 
                                            ? await this.stripe.confirmCardSetup(
                                                this.clientSecret,
                                                { 
                                                    payment_method: { 
                                                        card: this.cardNumber,
                                                        billing_details: {
                                                            name: this.nameCardValue.trim()
                                                        }
                                                    }
                                                }
                                            )
                                            : ( this.methodChoice == 'sepa' 
                                                    ? await this.stripe.confirmSepaDebitSetup(
                                                        this.clientSecret,
                                                        {
                                                            payment_method: {
                                                                sepa_debit: this.ibanEl,
                                                                billing_details: {
                                                                    name: this.nameIbanValue.trim(),
                                                                    email: this.emailIbanValue.trim(),
                                                                },
                                                            },
                                                        }
                                                    )
                                                    : await this.stripe.confirmPayPalSetup(this.clientSecret, { return_url: location.href }))

            if (error) {
                console.error('Could not confirm card setup @ Stripe: ', error)
                this.$vs.notify({
                    title: this.$t('dash.notifications.error_title'),
                    text : this.$t(`dash.settings.error.stripe.${ error.decline_code }`)
                });
                return
            }

            // Send new payment method to server (it will forward it to Stripe)
            const req = await this.$http.put(this.apiRoute, {
                pm: setupIntent.payment_method,
                type: this.methodChoice
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })

            // Check pm was correctly saved
            if (!req.ok) {
                this.$vs.notify({
                    title: this.$t('dash.notifications.error_title'),
                    text : this.$t('dash.settings.payment_method.failure')
                });
                return
            }


            this.appVizerConvertion()

            this.$vs.notify({
                title: this.$t('dash.settings.payment_method.changed.title'),
                text: this.$t('dash.settings.payment_method.changed.body'),
                color: '#b64985',
                icon: 'credit_card',
            })
            this.closePopUp()
            this.reset()
            
            // this.stripe.createToken(this.cardNumber).then((result) => {
            //     if (result.error) {
            //         this.stripeError = result.error.message;
            //     } else {
            //         const token = result.token.id
            //         alert('Thanks for donating.')
            //             //send the token to your server
            //             //clear the inputs

            //     }
            // })
        },

        appVizerConvertion(){
            (function (w, d, id) {
                if(w.av) { return; }
                var ts = new Date().getTime();
                w.avURL = w.avURL || 'https://appvizer.one';
                w.avPool = w.avPool || [];
                w.avPool.push({start: ts, id: id});
                w.av = function () { w.avPool.push(arguments) };
                var e = document.createElement("script");
                e.async = true;
                e.src = w.avURL + '/ariadne/v1/ariadne.js?ts=' + ts;
                d.getElementsByTagName("head")[0].appendChild(e);
            })(window, document, 'AP-30161');
            av("conversion");
        },

        async fetchSecret() {
            this.clientSecret = null
            // Fetch Stripe Setup Intent Secret
            const {data} = await this.$http.get(this.clientSecretRoute+`?methodChoice=${this.methodChoice}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }).catch(err => {
                alert('Could not fetch Stripe Secret. Please contact support')
                return {}
            })

            // Store secret
            this.clientSecret = data && data.client_secret
        },

        clearElementsInputs() {
            this.cardCvc.clear()
            this.cardExpiry.clear()
            this.cardNumber.clear()
            this.nameCardValue = ""
            this.ibanEl.clear()
            this.nameIbanValue = ""
            this.emailIbanValue = ""
        },

        clearCardErrors() {
            this.stripeError = ''
            this.cardCvcError = ''
            this.cardExpiryError = ''
            this.cardNumberError = ''
            this.cardNameError = ''
        },

        clearIbanErrors() {
            this.ibanError = ''
        },
			
        reset() {
            this.loading = false
            this.clearElementsInputs()
            this.clearCardErrors()
            this.clearIbanErrors()
        },


        //other
        handleClickOutside(event) {
            const targetElement = this.$refs.paymentMethodPopup;
            if (!this.loading && !targetElement.contains(event.target)) {
                this.closePopUp()
            }
        },

        cancel() {
            if (this.loading) return
            this.closePopUp()
            this.reset()
        }
    },

    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);
    },
};
</script>

